import React from "react";
import Text from "../../Tags/Text";
import { Button } from "../../ui/button";
import Image from "../../Tags/Image";
import { useCaptureEvent } from "../../../hooks/useCaptureEvent";

export default function Enterprise() {
  const captureEvent = useCaptureEvent();

  return (
    <div>
      <div className="leading-5 border-border border bg-background py-4 px-6 rounded-xl">
        <Text size="lg">Enterprise</Text>
        <Text>Contact us to tailor plan to your needs</Text>
        <div className="flex justify-center my-7">
          <Text size="h4">Custom</Text>
        </div>

        <Button className=" w-full mb-6" variant="purple_outline" asChild>
          <a
            href="https://meetings-na2.hubspot.com/primerole"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              captureEvent("BP_EnterpriseContact");
            }}
          >
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M16.333 14V9C16.333 4.85786 12.9751 1.5 8.83301 1.5C4.69087 1.5 1.33301 4.85786 1.33301 9V14M3.41634 16.5C2.26575 16.5 1.33301 15.5673 1.33301 14.4167V12.75C1.33301 11.5994 2.26575 10.6667 3.41634 10.6667C4.56693 10.6667 5.49967 11.5994 5.49967 12.75V14.4167C5.49967 15.5673 4.56693 16.5 3.41634 16.5ZM14.2497 16.5C13.0991 16.5 12.1663 15.5673 12.1663 14.4167V12.75C12.1663 11.5994 13.0991 10.6667 14.2497 10.6667C15.4003 10.6667 16.333 11.5994 16.333 12.75V14.4167C16.333 15.5673 15.4003 16.5 14.2497 16.5Z"
                stroke="currentColor"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <span className="ml-2">Contact us</span>
          </a>
        </Button>

        <div className="space-y-3 pb-4 border-b">
          <div className="flex items-center">
            <Image src="/images/icons/billing/user.svg" width="16" className="inline-block no-invert" />
            <span className="ml-2">Unlimited user seats</span>
          </div>
          <div className="flex items-center">
            <Image
              src="/images/icons/billing/bag-uparrow.svg"
              width="16"
              className="inline-block no-invert"
            />
            <span className="ml-2">All credits granted upfront</span>
          </div>
        </div>
        <div className="space-y-3 pb-5 border-b mt-5">
          <div className="flex items-center justify-between">
            <div className="inline-flex items-center">
              <Image src="/images/icons/billing/email.svg" width="16" className="inline-block no-invert" />
              <span className="ml-2">Reveal contact’s emails</span>
            </div>
            <div className="inline-flex items-center">
              <span className="mr-2">1</span>
              <Image src="/images/icons/billing/credit.svg" width="16" className="inline-block no-invert" />
            </div>
          </div>
          <div className="flex items-center justify-between">
            <div className="inline-flex items-center">
              <Image src="/images/icons/billing/phone.svg" width="16" className="inline-block no-invert" />
              <span className="ml-2">Reveal contact’s phones</span>
            </div>
            <div className="inline-flex items-center">
              <span className="mr-2">5</span>
              <Image src="/images/icons/billing/credit.svg" width="16" className="inline-block no-invert" />
            </div>
          </div>
          <div className="flex items-center justify-between">
            <div className="inline-flex items-center">
              <Image src="/images/icons/billing/company.svg" width="16" className="inline-block no-invert" />
              <span className="ml-2">Reveal companies info</span>
            </div>
            <div className="inline-flex items-center">
              <span className="mr-2">3</span>
              <Image src="/images/icons/billing/credit.svg" width="16" className="inline-block no-invert" />
            </div>
          </div>
        </div>
        <div className="space-y-3 mt-5">
          <div className="flex items-center">
            <Image
              src="/images/icons/untitledui/check-purple-outline.svg"
              width="16"
              className="inline-block no-invert"
            />
            <span className="ml-2">Work Email and Phone</span>
          </div>
          <div className="flex items-center">
            <Image
              src="/images/icons/untitledui/check-purple-outline.svg"
              width="16"
              className="inline-block no-invert"
            />
            <span className="ml-2">8+ Enterprise data provider waterfall</span>
          </div>
          <div className="flex items-center">
            <Image
              src="/images/icons/untitledui/check-purple-outline.svg"
              width="16"
              className="inline-block no-invert"
            />
            <span className="ml-2">Multi level email and phone verification</span>
          </div>
          <div className="flex items-center">
            <Image
              src="/images/icons/untitledui/check-purple-outline.svg"
              width="16"
              className="inline-block no-invert"
            />
            <span className="ml-2">Bulk CSV Enrichment</span>
          </div>
          <div className="flex items-center">
            <Image
              src="/images/icons/untitledui/check-purple-outline.svg"
              width="16"
              className="inline-block no-invert"
            />
            <span className="ml-2">150+ Company data points</span>
          </div>
          <div className="flex items-center">
            <Image
              src="/images/icons/untitledui/check-purple-outline.svg"
              width="16"
              className="inline-block no-invert"
            />
            <span className="ml-2">LinkedIn and Sales Navigator Extension</span>
          </div>
        </div>
        <div className="space-y-3 mt-6">
          <div className="flex items-center">
            <Image src="/images/icons/billing/star.svg" width="16" className="inline-block no-invert" />
            <span className="ml-2">Dedicated Customer Success Manager</span>
          </div>
          <div className="flex items-center">
            <Image src="/images/icons/billing/star.svg" width="16" className="inline-block no-invert" />
            <span className="ml-2">Custom API Limits & Enterprise SLAs</span>
          </div>
        </div>
      </div>
    </div>
  );
}
